module.exports = __webpack_public_path__ + "static/media/rating-1.446d11c7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/rating-1.svg
// module id = 1090
// module chunks = 0